import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/automation-architectures/components/AutomationArchitecturesInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/Header.tsx");
